import React, {Fragment} from 'react';
import PageTitle from '../../../../Layout/AppMain/PageTitle';
import Tabs from 'react-responsive-tabs';
import Historias from './component/Historias';



const tabsContent = [
    {
        title: 'Historias',
        content: <Historias/>
    }
];



function getTabs() {
    return tabsContent.map((tab, index) => ({
        title: tab.title,
        getContent: () => tab.content,
        key: index,
    }));
}

export default class HistoriasElementoComponent extends React.Component {

    render() {

        return (
            <Fragment>
                <PageTitle
                    heading="Elementos del  Juego: Historias y Lecturas"
                    subheading=""
                    icon="lnr-graduation-hat icon-gradient bg-mean-fruit"
                />
                <Tabs tabsWrapperClass="body-tabs body-tabs-layout" transform={false} showInkBar={true} items={getTabs()}/>
               
            </Fragment>
        );
    }
}


// WEBPACK FOOTER //
// src/Pages/ObjetivosDelJuego/elementosDelJuego/Historias-admin/index.js